export const ENDPOINTS = {
  AUTH: {
    ACCOUNT_ME_ADDRESS_SHIPPING: 'account/me/address/shipping',
    EULA_LATEST: 'account/eula/latest',
    EULA: 'account/eula',
  }
}
